<template>

  <div class="out-container">
    <div class="mycontainer">
      <h2>Please input your origin url</h2>
      <el-form :model="form" label-width="120px" label-position	="top">
        <!--  输入原始url  -->
        <el-form-item label="origin url" prop="originUrl" :rules="rules">
          <el-input v-model="form.originUrl" size="large" name="originUrl" v-loading="loading"	placeholder="please input url address" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="toCreateShortUrl" :disabled="loading">Generate short url</el-button>
        </el-form-item>

        <el-form-item label="short url" v-if="display">
          <el-input v-model="shortUrl" size="large" name="shortUrl" disabled/>
        </el-form-item>

        <el-form-item v-if="display">
          <el-button type="primary" @click="toCopyUrl" >Copy short url</el-button>
        </el-form-item>

      </el-form>
    </div>

  </div>

</template>


<script>
import {ref} from 'vue'
import {ElMessage} from 'element-plus'
import validateUtil from "@/util/validateUtil";
import tools from "@/util/Tools";
import myapi from '../util/api'
import messageUtil from '../util/messageUtil'
// 复制到剪贴板使用
import useClipboard from "vue-clipboard3";

export default {
    setup(){

      // 这里讲form使用ref包裹，进行响应式数据展示；如果不使用ref，输入框不能输入
      const form = ref({

      })

      let loading = ref(false);
      let shortUrl = ref('');
      let display = ref(false);


      // 地址使用的验证规则
      const rules = [
        {
          required: true,
          message: 'Please input url address',
          trigger: 'blur',
        },
        {
          type: 'url',
          message: 'Please input correct url address',
          trigger: ['blur'],
        },
      ];

      // 参考：https://blog.csdn.net/u011127019/article/details/125254862
      const { toClipboard } = useClipboard();

      const toCopyUrl = async () => {
        try {
          await toClipboard(shortUrl.value)
          console.log('shortUrl:',shortUrl.value)
          messageUtil.successMsg("Short url copied");
        } catch (e) {
          console.error(e)
        }
      }

      /**
       * 请求后端，生成 short url
       */
      async function toCreateShortUrl(){
        // 获取form表单中的数据值
        let originUrl = form.value.originUrl;
        console.log("form:",form.value.originUrl)
        if(!validateUtil.isURL(originUrl)){
          ElMessage.error('Please input correct url address')
          return ;
        }

        let params = {
          originUrl
        }

        // 封装3
        loading.value = true;
        let resp = await myapi.createShortUrl(params);
        loading.value = false;
        if(!resp){
          return;
        }

        // 非成功场景，框架会提示
        if(tools.isSuccResp(resp)){
          shortUrl.value = resp.data.data.shortUrl;
          display.value = true;
          console.log("shortUrl:",shortUrl)
          messageUtil.successMsg("Short url create successed");
          return ;
        }

      }


      // 可能无法再setup中，引用挂载的proxy的属性
      // 参照地址： https://www.jianshu.com/p/f8b14062337a
      // https://blog.csdn.net/Lschange/article/details/112314580
      return {form,rules,loading,toCreateShortUrl,shortUrl,display,toCopyUrl}
    },

}
</script>

<style scoped>

.out-container{
  background-color: #f9fbff;
  width: 100%;
}
.mycontainer{
  padding: 30px;
  text-align: center;
  /*border: solid 1px var(--el-border-color);*/
  display: inline-block;
  width: 50%;
  box-sizing: border-box;
  margin: 10px auto;
  vertical-align: top;
  border-radius: 5px;

}
</style>
